module.exports = __webpack_public_path__ + "static/media/ulti-frisbee.0585a153.png";